/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

import {
  MapPin,
  Mail,
  Phone,
  Clock,
  MessageCircle,
  Send,
  User,
  Building2,
  Navigation,
  Globe,
  Star,
  ChevronRight,
  AlertCircle,
  CheckCircle,
  Headphones,
} from "lucide-react";
import Cookies from "js-cookie";
import Loader from "../Components/Loader";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      },
      isSubmitting: false,
      submitSuccess: false,
      submitError: "",
      errors: {},
      agreedToClarification: false,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
      errors: {
        ...this.state.errors,
        [name]: "",
      },
    });
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "Ad Soyad zorunludur";
    } else if (formData.name.trim().length < 2) {
      errors.name = "Ad Soyad en az 2 karakter olmalıdır";
    }

    if (!formData.email.trim()) {
      errors.email = "E-posta zorunludur";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = "Geçerli bir e-posta adresi giriniz";
      }
    }

    if (!formData.message.trim()) {
      errors.message = "Mesaj zorunludur";
    } else if (formData.message.trim().length < 10) {
      errors.message = "Mesaj en az 10 karakter olmalıdır";
    } else if (formData.message.trim().length > 2000) {
      errors.message = "Mesaj en fazla 2000 karakter olabilir";
    }

    if (formData.phone.trim() && formData.phone.trim().length < 10) {
      errors.phone = "Geçerli bir telefon numarası giriniz";
    }

    if (!this.state.agreedToClarification) {
      errors.agreedToClarification = "Aydınlatma metnini onaylamanız gerekmektedir";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({
      isSubmitting: true,
      submitError: "",
      submitSuccess: false,
    });

    try {
      const token = Cookies.get("token");
      const { formData } = this.state;

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/contact-form-submit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            token: token || null,
          }),
        }
      );

      const text = await response.text();
      let data;

      try {
        data = JSON.parse(text);
      } catch (e) {
        data = { message: text };
      }

      if (data.message === "basarili") {
        this.setState({
          isSubmitting: false,
          submitSuccess: true,
          submitError: "",
          formData: {
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
          },
        });

        setTimeout(() => {
          this.setState({ submitSuccess: false });
        }, 5000);
      } else {
        let errorMessage = "Mesaj gönderilemedi. Lütfen tekrar deneyin.";

        switch (data.message) {
          case "eksikbilgi":
            errorMessage = "Lütfen tüm zorunlu alanları doldurun.";
            break;
          case "gecersizemail":
            errorMessage = "Geçerli bir e-posta adresi giriniz.";
            break;
          case "mesajuzunluk":
            errorMessage = "Mesaj 10-2000 karakter arasında olmalıdır.";
            break;
          case "Çok fazla mesaj gönderdiniz. Lütfen bir saat sonra tekrar deneyin.":
            errorMessage =
              "Çok fazla mesaj gönderdiniz. Lütfen bir saat sonra tekrar deneyin.";
            break;
          case "servererror":
            errorMessage = "Sunucu hatası. Lütfen daha sonra tekrar deneyin.";
            break;
          default:
            errorMessage = "Bir hata oluştu. Lütfen tekrar deneyin.";
        }

        this.setState({
          isSubmitting: false,
          submitError: errorMessage,
        });
      }
    } catch (error) {
      this.setState({
        isSubmitting: false,
        submitError:
          "Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.",
      });
    }
  };

  render() {
    const { formData, isSubmitting, submitSuccess, submitError, errors } =
      this.state;

    return (
      <>
        <Loader />

        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />

        <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "80px 0 60px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                pointerEvents: "none",
              }}
            />

            <div
              className="container"
              style={{ position: "relative", zIndex: 1 }}
            >
              <div className="row">
                <div className="text-center">
                  <h6
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "14px",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "15px",
                    }}
                  >
                    📞 İLETİŞİM
                  </h6>
                  <h1
                    style={{
                      color: "white",
                      fontSize: "42px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      lineHeight: "1.2",
                    }}
                  >
                    Bizimle İletişime Geçin
                  </h1>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "18px",
                      lineHeight: "1.6",
                      maxWidth: "800px",
                      margin: "0 auto",
                    }}
                  >
                    Sorularınız, önerileriniz veya işbirliği teklifleriniz için
                    bizimle iletişime geçebilirsiniz. Size en kısa sürede dönüş
                    yapacağız.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "60px 0", background: "#f8fafc" }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-40">
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      borderRadius: "20px",
                      padding: "40px",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                      border: "1px solid rgba(226, 232, 240, 0.5)",
                    }}
                  >
                    <div style={{ marginBottom: "30px" }}>
                      <h3
                        style={{
                          fontSize: "28px",
                          fontWeight: "700",
                          marginBottom: "10px",
                          color: "#1e293b",
                        }}
                      >
                        Mesaj Gönderin
                      </h3>
                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "16px",
                          lineHeight: "1.6",
                          margin: "0",
                        }}
                      >
                        Formu doldurarak bizimle iletişime geçebilirsiniz. En
                        kısa sürede size dönüş yapacağız.
                      </p>
                    </div>

                    {submitSuccess && (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                          border: "1px solid #10b981",
                          borderRadius: "12px",
                          padding: "15px 20px",
                          marginBottom: "25px",
                          color: "#065f46",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <CheckCircle size={16} />
                        Mesajınız başarıyla gönderildi! En kısa sürede size
                        dönüş yapacağız.
                      </div>
                    )}

                    {submitError && (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
                          border: "1px solid #ef4444",
                          borderRadius: "12px",
                          padding: "15px 20px",
                          marginBottom: "25px",
                          color: "#991b1b",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <AlertCircle size={16} />
                        {submitError}
                      </div>
                    )}

                    <form onSubmit={this.handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            Ad Soyad *
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={this.handleInputChange}
                            required
                            style={{
                              width: "100%",
                              padding: "15px 18px",
                              border: errors.name
                                ? "2px solid #ef4444"
                                : "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              transition:
                                "border-color 0.2s ease, box-shadow 0.2s ease",
                              background: "#ffffff",
                            }}
                            onFocus={(e) => {
                              if (!errors.name) {
                                e.target.style.borderColor = "#667eea";
                                e.target.style.boxShadow =
                                  "0 0 0 3px rgba(102, 126, 234, 0.1)";
                              }
                            }}
                            onBlur={(e) => {
                              if (!errors.name) {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                              }
                            }}
                          />
                          {errors.name && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "12px",
                                marginTop: "5px",
                              }}
                            >
                              {errors.name}
                            </p>
                          )}
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            E-Posta *
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={this.handleInputChange}
                            required
                            style={{
                              width: "100%",
                              padding: "15px 18px",
                              border: errors.email
                                ? "2px solid #ef4444"
                                : "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              transition:
                                "border-color 0.2s ease, box-shadow 0.2s ease",
                              background: "#ffffff",
                            }}
                            onFocus={(e) => {
                              if (!errors.email) {
                                e.target.style.borderColor = "#667eea";
                                e.target.style.boxShadow =
                                  "0 0 0 3px rgba(102, 126, 234, 0.1)";
                              }
                            }}
                            onBlur={(e) => {
                              if (!errors.email) {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                              }
                            }}
                          />
                          {errors.email && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "12px",
                                marginTop: "5px",
                              }}
                            >
                              {errors.email}
                            </p>
                          )}
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            Telefon
                          </label>
                          <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={this.handleInputChange}
                            style={{
                              width: "100%",
                              padding: "15px 18px",
                              border: errors.phone
                                ? "2px solid #ef4444"
                                : "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              transition:
                                "border-color 0.2s ease, box-shadow 0.2s ease",
                              background: "#ffffff",
                            }}
                            onFocus={(e) => {
                              if (!errors.phone) {
                                e.target.style.borderColor = "#667eea";
                                e.target.style.boxShadow =
                                  "0 0 0 3px rgba(102, 126, 234, 0.1)";
                              }
                            }}
                            onBlur={(e) => {
                              if (!errors.phone) {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                              }
                            }}
                          />
                          {errors.phone && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "12px",
                                marginTop: "5px",
                              }}
                            >
                              {errors.phone}
                            </p>
                          )}
                        </div>

                        <div className="col-md-6 mb-20">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            Konu
                          </label>
                          <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={this.handleInputChange}
                            style={{
                              width: "100%",
                              padding: "15px 18px",
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              transition:
                                "border-color 0.2s ease, box-shadow 0.2s ease",
                              background: "#ffffff",
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#667eea";
                              e.target.style.boxShadow =
                                "0 0 0 3px rgba(102, 126, 234, 0.1)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e2e8f0";
                              e.target.style.boxShadow = "none";
                            }}
                          />
                        </div>

                        <div className="col-12 mb-25">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#374151",
                            }}
                          >
                            Mesajınız *
                          </label>
                          <textarea
                            name="message"
                            value={formData.message}
                            onChange={this.handleInputChange}
                            required
                            rows="5"
                            placeholder="Lütfen mesajınızı detaylı bir şekilde yazın..."
                            style={{
                              width: "100%",
                              padding: "15px 18px",
                              border: errors.message
                                ? "2px solid #ef4444"
                                : "2px solid #e2e8f0",
                              borderRadius: "12px",
                              fontSize: "15px",
                              transition:
                                "border-color 0.2s ease, box-shadow 0.2s ease",
                              background: "#ffffff",
                              resize: "vertical",
                              minHeight: "120px",
                            }}
                            onFocus={(e) => {
                              if (!errors.message) {
                                e.target.style.borderColor = "#667eea";
                                e.target.style.boxShadow =
                                  "0 0 0 3px rgba(102, 126, 234, 0.1)";
                              }
                            }}
                            onBlur={(e) => {
                              if (!errors.message) {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.boxShadow = "none";
                              }
                            }}
                          />
                          {errors.message && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "12px",
                                marginTop: "5px",
                              }}
                            >
                              {errors.message}
                            </p>
                          )}
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#64748b",
                              marginTop: "5px",
                              textAlign: "right",
                            }}
                          >
                            {formData.message.length}/2000
                          </p>
                        </div>

                        <div className="col-12 mb-25">
                          <label
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={this.state.agreedToClarification}
                              onChange={(e) =>
                                this.setState({
                                  agreedToClarification: e.target.checked,
                                  errors: {
                                    ...this.state.errors,
                                    agreedToClarification: "",
                                  },
                                })
                              }
                              style={{
                                width: "18px",
                                height: "18px",
                                marginTop: "2px",
                                cursor: "pointer",
                                accentColor: "#667eea",
                              }}
                            />
                            <span>
                              <a
                                href="/iletisim_formu_aydinlatma_metni"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#667eea",
                                  textDecoration: "underline",
                                  fontWeight: "600",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                İletişim Formu Aydınlatma Metni
                              </a>
                              'ni okudum ve kabul ediyorum. *
                            </span>
                          </label>
                          {this.state.errors.agreedToClarification && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "12px",
                                marginTop: "5px",
                              }}
                            >
                              {this.state.errors.agreedToClarification}
                            </p>
                          )}
                        </div>

                        <div className="col-12">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="universal-button"
                            style={{
                              background: isSubmitting
                                ? "#94a3b8"
                                : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              color: "white",
                              padding: "18px 40px",
                              border: "none",
                              borderRadius: "12px",
                              fontSize: "16px",
                              fontWeight: "600",
                              cursor: isSubmitting ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              justifyContent: "center",
                              width: "100%",
                              boxShadow: isSubmitting
                                ? "none"
                                : "0 8px 25px rgba(102, 126, 234, 0.3)",
                            }}
                          >
                            {isSubmitting ? (
                              <>
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #ffffff",
                                    borderTop: "2px solid transparent",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                                Gönderiliyor...
                              </>
                            ) : (
                              <>
                                <Send size={18} />
                                Mesajı Gönder
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="col-lg-6 mb-40">
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                      border: "1px solid rgba(226, 232, 240, 0.5)",
                      height: "100%",
                      minHeight: "500px",
                    }}
                  >
                    <div style={{ padding: "30px 30px 20px" }}>
                      <h3
                        style={{
                          fontSize: "24px",
                          fontWeight: "700",
                          marginBottom: "10px",
                          color: "#1e293b",
                        }}
                      >
                        📍 Konumumuz
                      </h3>
                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "15px",
                          margin: "0",
                        }}
                      >
                        Ofisimize nasıl ulaşabileceğinizi haritadan
                        görebilirsiniz
                      </p>
                    </div>

                    <div style={{ height: "400px", width: "100%" }}>
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.123456789!2d36.8501086!3d37.5858075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152ddbcbc1b1a123%3A0xe7c87d2054cb16ca!2sErenis%20Otomotiv%20Kiralama%20Yirmiikig%C3%BCn%20Turgut%20%C3%96zal%20Blv.%20Umutkent%20sitesi%20Alt%C4%B1%2046100%20Oniki%C5%9Fubat%2FKahramanmara%C5%9F!5e0!3m2!1str!2str!4v1710000000000"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ padding: "60px 0", background: "white" }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 mb-30">
                  <div
                    className="contact-card universal-card universal-shimmer"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      borderRadius: "16px",
                      padding: "40px 30px",
                      textAlign: "center",
                      boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(226, 232, 240, 0.5)",
                      height: "100%",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="universal-pattern"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                        pointerEvents: "none",
                      }}
                    />

                    <div style={{ position: "relative", zIndex: 1 }}>
                      <div
                        className="universal-icon"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          width: "70px",
                          height: "70px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 25px",
                          color: "white",
                          boxShadow: "0 8px 25px rgba(102, 126, 234, 0.25)",
                        }}
                      >
                        <MapPin size={30} />
                      </div>

                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          marginBottom: "15px",
                          color: "#1e293b",
                        }}
                      >
                        Adres
                      </h4>

                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "15px",
                          lineHeight: "1.6",
                          margin: "0 0 20px 0",
                        }}
                      >
                        Yirmiikigün, Turgut Özal Blv. Umutkent sitesi Altı,
                        46100 Onikişubat/Kahramanmaraş
                      </p>

                      <a
                        href="https://www.google.com/maps/dir//Erenis+Otomotiv+Kiralama+Yirmiikig%C3%BCn+Turgut+%C3%96zal+Blv.+Umutkent+sitesi+Alt%C4%B1+46100+Oniki%C5%9Fubat%2FKahramanmara%C5%9F/@37.5858075,36.8501086,10z/data=!4m5!4m4!1m0!1m2!1m1!1s0x152ddbcbc1b1a123:0xe7c87d2054cb16ca"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="universal-button"
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          padding: "12px 20px",
                          borderRadius: "8px",
                          textDecoration: "none",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
                        }}
                      >
                        <Navigation size={16} />
                        Haritada Gör
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 mb-30">
                  <div
                    className="contact-card universal-card universal-shimmer"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      borderRadius: "16px",
                      padding: "40px 30px",
                      textAlign: "center",
                      boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(226, 232, 240, 0.5)",
                      height: "100%",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="universal-pattern"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                        pointerEvents: "none",
                      }}
                    />
                    <div style={{ position: "relative", zIndex: 1 }}>
                      <div
                        className="universal-icon"
                        style={{
                          background:
                            "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          width: "70px",
                          height: "70px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 25px",
                          color: "white",
                          boxShadow: "0 8px 25px rgba(16, 185, 129, 0.25)",
                        }}
                      >
                        <MessageCircle size={30} />
                      </div>
                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          marginBottom: "15px",
                          color: "#1e293b",
                        }}
                      >
                        Hızlı Destek
                      </h4>
                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "15px",
                          lineHeight: "1.6",
                          marginBottom: "20px",
                        }}
                      >
                        7/24 canlı destek ekibimizle anında iletişime geçin
                      </p>

                      <a
                        href="/iletisim"
                        className="universal-button"
                        style={{
                          background:
                            "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          color: "white",
                          padding: "12px 20px",
                          borderRadius: "8px",
                          textDecoration: "none",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "0 8px 25px rgba(16, 185, 129, 0.3)",
                        }}
                      >
                        <Headphones size={16} />
                        Destek Al
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-6 col-md-6 mb-30">
                  <div
                    className="contact-card universal-card universal-shimmer"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                      borderRadius: "16px",
                      padding: "40px 30px",
                      textAlign: "center",
                      boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                      border: "1px solid rgba(226, 232, 240, 0.5)",
                      height: "100%",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="universal-pattern"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                        pointerEvents: "none",
                      }}
                    />

                    <div style={{ position: "relative", zIndex: 1 }}>
                      <div
                        className="universal-icon"
                        style={{
                          background:
                            "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                          width: "70px",
                          height: "70px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 25px",
                          color: "white",
                          boxShadow: "0 8px 25px rgba(59, 130, 246, 0.25)",
                        }}
                      >
                        <Mail size={30} />
                      </div>

                      <h4
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          marginBottom: "15px",
                          color: "#1e293b",
                        }}
                      >
                        E-Posta
                      </h4>

                      <p
                        style={{
                          color: "#64748b",
                          fontSize: "15px",
                          lineHeight: "1.6",
                          marginBottom: "20px",
                        }}
                      >
                        Sorularınız için bize e-posta gönderebilirsiniz
                      </p>

                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=info@nmuniversalteam.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="universal-button"
                        style={{
                          background:
                            "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                          color: "white",
                          padding: "12px 20px",
                          borderRadius: "8px",
                          textDecoration: "none",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "0 8px 25px rgba(59, 130, 246, 0.3)",
                        }}
                      >
                        <Send size={16} />
                        E-Posta Gönder
                      </a>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <style jsx>{`
            @keyframes spin {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }

            .universal-card {
              cursor: pointer;
              transition: all 0.3s ease;
              will-change: transform, box-shadow;
              backface-visibility: hidden;
              perspective: 1000px;
              flex: 1;
              display: flex;
              flex-direction: column;
              transform: translateY(0);
            }

            .universal-card:hover {
              transform: translateY(-8px) translateZ(0);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12) !important;
            }

            .universal-icon {
              transition: transform 0.25s ease;
              will-change: transform;
            }

            .universal-card:hover .universal-icon {
              transform: scale(1.05) translateZ(0);
            }

            .universal-button {
              transition: transform 0.25s ease, box-shadow 0.25s ease;
              position: relative;
              overflow: hidden;
              will-change: transform, box-shadow;
            }

            .universal-button:before {
              content: "";
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.2),
                transparent
              );
              transition: left 0.4s ease;
            }

            .universal-card:hover .universal-button:before {
              left: 100%;
            }

            .universal-card:hover .universal-button {
              transform: translateY(-2px) translateZ(0);
              box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3) !important;
            }

            .universal-pattern {
              transition: opacity 0.3s ease;
            }

            .universal-card:hover .universal-pattern {
              opacity: 1.2;
            }

            .universal-shimmer {
              position: relative;
              overflow: hidden;
            }

            .universal-shimmer:before {
              content: "";
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.3),
                transparent
              );
              transition: left 0.6s ease;
            }

            .universal-card:hover .universal-shimmer:before {
              left: 100%;
            }

            .row {
              margin-left: -15px;
              margin-right: -15px;
            }

            .col-lg-5,
            .col-lg-6,
            .col-md-6,
            .col-12 {
              padding-left: 15px;
              padding-right: 15px;
            }

            .mb-30 {
              margin-bottom: 30px;
            }

            .mb-40 {
              margin-bottom: 40px;
            }

            .mb-20 {
              margin-bottom: 20px;
            }

            .mb-25 {
              margin-bottom: 25px;
            }

            @media (max-width: 768px) {
              .row {
                margin-left: -10px;
                margin-right: -10px;
              }

              .col-lg-5,
              .col-lg-6,
              .col-md-6,
              .col-12 {
                padding-left: 10px;
                padding-right: 10px;
              }

              .mb-30 {
                margin-bottom: 25px;
              }

              .mb-40 {
                margin-bottom: 30px;
              }

              .universal-card:hover {
                transform: translateY(-4px) translateZ(0);
              }
            }

            .universal-card,
            .universal-icon,
            .universal-button {
              transform: translateZ(0);
            }
          `}</style>
        </div>

        <Footer />
      </>
    );
  }
}
